module.exports = __webpack_public_path__ + "img/navigation.e412d8aa.svg";